import { Alert } from "antd";
import { Button } from "components/Button/Button";
import { CancelButton } from "components/Form/components/CancelButton/CancelButton";
import { SubmitLock } from "components/Form/components/SubmitLock/SubmitLock";
import { Form } from "components/Form/components/Form/Form";
import { FormComponentProps } from "components/Form/components/FormComponentProps";
import { IconCollection } from "components/Icon/IconCollection";
import { UncommittedResourceListField } from "containers/Resources/screens/ResourcesSingle/components/GitAction/commitActions/formComponents/UncommittedResourceListField";
import { UncommittedData } from "containers/Resources/screens/ResourcesSingle/components/GitAction/commitActions/utils";
import { Field } from "react-final-form";
import styles from "../../GitAction.module.scss";

interface BulkResetFormProps extends FormComponentProps {
    uncommittedRecordList: UncommittedData[];
    closeModal: () => void;
    handleSubmit: (data) => Promise<any>;
    submitting: boolean;
    values: any;
}

export const BulkResetForm = ({
    uncommittedRecordList,
    closeModal,
    handleSubmit,
    submitting,
    values,
}: BulkResetFormProps) => {
    return (
        <Form onSubmit={handleSubmit}>
            <SubmitLock locked={submitting}>
                <Form.Row>
                    <Field name="records" id="records" fieldProps={{}} fieldAttr={{}}>
                        {(props: FormComponentProps) => (
                            <UncommittedResourceListField
                                uncommittedRecordList={uncommittedRecordList}
                                {...props}
                            />
                        )}
                    </Field>
                </Form.Row>
            </SubmitLock>
            <div className={styles.resetAlert}>
                <Alert
                    message="Warning: resetting to status in git will overwrite existing changes!"
                    type="warning"
                    showIcon
                />
            </div>
            <Form.Row>
                <CancelButton onClick={() => closeModal()} disabled={submitting} />
                <Button
                    submit
                    loading={submitting}
                    variation="primary"
                    label="Bulk reset"
                    icon={IconCollection.undo}
                    disabled={values?.records?.length === 0}
                />
            </Form.Row>
        </Form>
    );
};
